/** Shared timing constants for all expand/collapse micro-animations. */
export const COLLAPSE_ANIMATION = {
  duration: 0.15,
  ease: 'easeOut' as const,
};
